// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"297":"a1fccba2","950":"f84bad4d"}[chunkId] + ".css";
};